"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isValidStage;

function isValidStage(stage, video) {
  if (!video) {
    return false;
  }

  var assetIds = video.assetIds,
      clips = video.clips,
      notesToTheEditor = video.notesToTheEditor,
      videoType = video.videoType,
      creativeInput = video.creativeInput,
      outputs = video.outputs;

  if (stage === 2) {
    return Boolean(assetIds && assetIds.length);
  }

  if (stage === 3) {
    return Boolean(isValidStage(2, video) && clips && clips.length);
  }

  if (stage === 4) {
    return Boolean(isValidStage(3, video) && videoType && notesToTheEditor && creativeInput);
  }

  if (stage === 5) {
    return Boolean(isValidStage(4, video) && outputs && outputs.length);
  }

  return stage === 1;
}